import { useT } from '../../i18n';
import s from './Dialog.module.css';

export function UnsupportedDialog({ missing }: { missing: string[] }) {
  const t = useT();
  return (
    <div className={s.backdrop} role="alertdialog" aria-modal="true" aria-labelledby="unsupported-title">
      <div className={s.dialog}>
        <h2 id="unsupported-title">{t('unsupportedTitle')}</h2>
        <p>{t('unsupportedBody')}</p>
        {missing.length > 0 && (
          <p className={s.muted}>{t('unsupportedMissing', { list: missing.join(', ') })}</p>
        )}
      </div>
    </div>
  );
}
